type PaymentStatus = 'success' | 'failure' | 'initial'

export interface PaymentRequestPayload {
  error_url: string
  id: number
  status: PaymentStatus
  success_url: string
  token: string
}

interface Response {
  handlePaymentRequestChange: (payload: PaymentRequestPayload) => void
}

export const usePaymentRedirect = (): Response => {
  const handlePaymentRequestChange = (payload: PaymentRequestPayload) => {
    window.location.href = payload.status === 'success' ? payload.success_url : payload.error_url
  }

  return {
    handlePaymentRequestChange,
  }
}
